import { Drawer } from '@mantine/core'
import { OrderStatusUpdate } from '../status-update/OrderStatusUpdate'
import classes from './StatusUpdateDrawer.module.css'

interface StatusUpdateDrawerProps {
  opened: boolean
  onClose: () => void
  onStatusUpdate?: (status: string) => void
  orderId: string
  currentStatus: string
  lastUpdateTime?: string
}

export function StatusUpdateDrawer({
  opened,
  onClose,
  onStatusUpdate,
  orderId,
  currentStatus,
  lastUpdateTime,
}: StatusUpdateDrawerProps) {
  function handleSuccess(newStatus: string) {
    if (onStatusUpdate) {
      onStatusUpdate(newStatus)
    }
    onClose()
  }

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="bottom"
      title="Update Order Status"
      radius="md"
      withCloseButton
      classNames={{
        header: classes.drawerHeader,
        title: classes.drawerTitle,
        close: classes.drawerClose,
        content: classes.drawerContent,
        body: classes.drawerBody,
      }}
    >
      <OrderStatusUpdate
        orderId={orderId}
        currentStatus={currentStatus}
        lastUpdateTime={lastUpdateTime}
        onSuccess={handleSuccess}
      />
    </Drawer>
  )
}
